import React from 'react';
import { Route, Routes } from 'react-router-dom';
import Instance from './Instance/Instance';

import './Public.css';

const Public = () => {
    return (
        <div className="Public">
            <div className="wrapper">
                <Routes>
                    {/* /p is the canonical public prefix; /public is kept as a
                        backward-compatible alias for links already in the wild
                        (e-shop, e-mails, printed QR codes, WordPress module). */}
                    <Route path="/p/:slug/*" element={<Instance />} />
                    <Route path="/public/:slug/*" element={<Instance />} />
                </Routes>
           </div>
        </div>
    );
}

export default Public;
